(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/stats.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/stats.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.Statistics = Backbone.Model.extend({
    defaults: {
      id: undefined,
      isAnySet: true,
      latest: false,
      matchstart: false,
      meetings: false,
      oddset: true,
      seriestable: false,
      showFirstFour: false,
      showTTT: true,
      svf: true,
      ttt: false,
      xpert: false
    },

    fetchGameAnalyzes: function() {
      var currentDraw = svs.tipset.collections.draws.getCurrentDraw();
      var product = currentDraw.get('productId');
      var drawNumber = currentDraw.get('drawNumber');

      if (this.isFetching[product + '_' + drawNumber]) {
        return;
      }

      this.isFetching[product + '_' + drawNumber] = true;

      var self = this;
      svs.sport.gameAnalyzes.getGameAnalyzes({
        callback: function(error, gameAnalyzes, analyzesByEvent) {
          if (error) {
            return;
          }

          var storedGameAnalyzes = self.get('storedGameAnalyzes') || {};

          gameAnalyzes = gameAnalyzes.map(function(gameAnalysis) {
            var isChecked = Boolean(storedGameAnalyzes[gameAnalysis.authorProfile.id]);
            return Object.assign({}, gameAnalysis, {
              buttonId: 'gameAnalysis-' + gameAnalysis.id,
              isChecked: isChecked
            });
          });

          self.set('gameAnalyzes', gameAnalyzes);
          self.set('analyzesByEvent', analyzesByEvent);
          delete self.isFetching[product + '_' + drawNumber];
        },
        drawNumber: drawNumber,
        product: product
      });
    },

    handleChangeGameAnalyzes: function() {
      var currentStoredGameAnalyzes = this.get('storedGameAnalyzes') || {};
      var storedGameAnalyzes = this.get('gameAnalyzes');
      if (!storedGameAnalyzes) {
        return;
      }
      storedGameAnalyzes = storedGameAnalyzes.reduce(function(acc, gameAnalysis) {
        var storeGameAnalysis = {};
        storeGameAnalysis[gameAnalysis.authorProfile.id] = gameAnalysis.isChecked;
        return Object.assign({}, acc, storeGameAnalysis);
      }, {});
      this.set('storedGameAnalyzes', Object.assign({}, currentStoredGameAnalyzes, storedGameAnalyzes));
    },

    isFetching: {},

    log: new svs.core.log.Logger('svs.tipset.models.Statistics'),

    initialize: function() {
      this.set(
        {
          id: svs.tipset.models.gameDefinitions.getAPIName(svs.tipset.collections.draws.getCurrentDraw().get('productId')),
          hasSpelanalys: svs.tipset.models.gameDefinitions.get('hasSpelanalys')
        },
        { silent: true }
      );

      this.listenTo(svs.tipset.models.play, 'changeSingleRows', this.setData);
      this.listenTo(this, 'change', this.handleChangeGameAnalyzes);
    },

    setData: function() {
      if (
        svs.tipset.models.play &&
        !svs.tipset.models.play.get('isSingleRow')
      ) {
        var dataFromLocalStorage = svs.tipset.objects.localstorageHandler
          ? svs.tipset.objects.localstorageHandler.getTipsInfo()
          : undefined;
        if (dataFromLocalStorage) {
          if (
            (this.get('id') !== 'T8STRYK' && this.get('id') !== 'STRYK') ||
            this.get('id') === 'POWERPLAY'
          ) {
            this.set('showTTT', false);
            this.set('ttt', false);
          }
          delete dataFromLocalStorage.showActionbar;
          delete dataFromLocalStorage.showTTT;
          delete dataFromLocalStorage.showTTTToggle;
          _.extend(this.attributes, dataFromLocalStorage);
        }

        if (this.get('id') === 'POWERPLAY') this.set('ttt', false);
        if (this.get('latest')) {
          this.handleStatisticChoices();
        } else {
          this.trigger('changeFromStorage', this);
        }
      }
    },

    save: function() {
      svs.tipset.objects.localstorageHandler.saveTipsInfo();
    },

    anyTrue: function() {
      var isAnySet = false;
      var i;
      for (i in this.attributes) {
        if (this.isRelevant(i) && this.get(i)) {
          isAnySet = true;
          break;
        }
      }

      var gameAnalyzes = this.get('gameAnalyzes');
      for (i = 0; i < gameAnalyzes.length; ++i) {
        if (gameAnalyzes[i].isChecked) {
          isAnySet = true;
          break;
        }
      }

      return isAnySet;
    },

    hideAll: function() {
      for (var i in this.attributes) {
        if (this.isRelevant(i)) {
          this.set(i, false, { silent: true });
        }
      }

      var gameAnalyzes = this.get('gameAnalyzes');
      gameAnalyzes = gameAnalyzes.map(function(gameAnalysis) {
        return Object.assign({}, gameAnalysis, {
          isChecked: false
        });
      });
      this.set('storedGameAnalyzes', {}, { silent: true });
      this.set('gameAnalyzes', gameAnalyzes, { silent: true });
      this.set('isAnySet', false);
      this.trigger('allStatsUpdated');
    },

    showAll: function() {
      for (var i in this.attributes) {
        if (this.isRelevant(i)) {
          this.set(i, true, { silent: true });
        }
      }
      var gameAnalyzes = this.get('gameAnalyzes');
      gameAnalyzes = gameAnalyzes.map(function(gameAnalysis) {
        return Object.assign({}, gameAnalysis, {
          isChecked: true
        });
      });
      this.set('gameAnalyzes', gameAnalyzes, { silent: true });
      this.set('isAnySet', true);
      this.trigger('allStatsUpdated');
    },

    isRelevant: function(attr) {
      return (
        attr != 'id' &&
        attr != 'showFirstFour' &&
        attr != 'hasSpelanalys' &&
        attr != 'isAnySet' &&
        attr != 'xtopp' &&
        attr != 'showTTT' &&
        attr != 'showTTTToggle' &&
        attr != 'gameAnalyzes' &&
        attr != 'storedGameAnalyzes' &&
        attr != 'analyzesByEvent' &&
        (attr != 'ttt' || (this.attributes.showTTT && attr == 'ttt'))
      );
    },

    getStatistics: function() {
      return this.attributes;
    },

    statisticsSet: function() {
      this.trigger('statisticsSet');
      this.save();
    },

    toggleStats: function(toToggle) {
      if (toToggle.indexOf('gameAnalysis-') > -1) {
        var gameAnalyzes = this.get('gameAnalyzes');
        gameAnalyzes = gameAnalyzes.map(function(gameAnalysis) {
          if (gameAnalysis.buttonId === toToggle) {
            return Object.assign({}, gameAnalysis, {
              isChecked: !gameAnalysis.isChecked
            });
          }
          return gameAnalysis;
        });
        this.set('gameAnalyzes', gameAnalyzes, { silent: true });
      } else {
        this.set(toToggle, !this.get(toToggle), { silent: true });
      }
      this.set('isAnySet', this.anyTrue());
      this.trigger('change', this);
    },

    toggleHideAll: function() {
      if (this.anyTrue()) {
        this.hideAll();
      } else {
        this.showAll();
      }
    },

    handleStatisticChoices: function() {
      if (this.get('latest')) {
        if (!svs.tipset.collections.lastMatches) {
          svs.tipset.collections.lastMatches = new svs.tipset.collections.LastMatches();
        } else {
          svs.tipset.collections.lastMatches.reset();
        }
        this.listenToOnce(
          svs.tipset.collections.lastMatches,
          'lastMatchesReady',
          this.statisticsSet
        );
        svs.tipset.collections.lastMatches.fetch({ remove: false });
      } else {
        this.statisticsSet();
      }
    }
  });
})(Backbone, _, svs);

 })(window);